import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { formatMoney, formatDate } from '../../../../shared/fund/format';
import Item from './item';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: 16px 0;
`;

// eslint-disable-next-line complexity
export default function Fund({ fund }) {
  const {
    dpFundName,
    dpFundInceptionDate,
    dpFundMinimumInvestment,
    dpFundApir,
    dpFundIsin,
    dpFundId,
    dpFundCurrency,
    dpFundLegalStructure,
    dpFundDomicile,
    dpFundCategory,
    dpFundInvestmentVehicleType,
    geographicalFocus,
    dpStockCode,
    dpStockExchange,
    lwStockCode,
    dpFundType,
  } = fund;

  const inceptionDate = dpFundInceptionDate ? formatDate(dpFundInceptionDate) : null;
  const fundMinimumInvestment = dpFundMinimumInvestment > 0
    ? formatMoney(dpFundMinimumInvestment)
    : null;

  return (
    <Container>
      <Item label="Fund Name" value={dpFundName} />
      {!!dpFundApir && <Item label="APIR" value={dpFundApir} />}
      {!!dpFundId && <Item label="Data Provider ID" value={dpFundId} />}
      {!!dpFundIsin && <Item label="ISIN" value={dpFundIsin} />}
      {!!inceptionDate && <Item label="Inception Date" value={inceptionDate} />}
      {!!dpFundCurrency && <Item label="Currency" value={dpFundCurrency} />}
      {!!dpFundLegalStructure && <Item label="Legal Structure" value={dpFundLegalStructure} />}
      {!!dpFundDomicile && <Item label="Domicile" value={dpFundDomicile} />}
      {!!dpFundCategory && <Item label="Category" value={dpFundCategory} />}
      {!!fundMinimumInvestment && (
        <Item label="Minimum Investment" value={fundMinimumInvestment} />
      )}
      {!!dpFundInvestmentVehicleType && (
        <Item label="Investment Vehicle Type" value={dpFundInvestmentVehicleType} />
      )}
      {!!geographicalFocus && (
        <Item label="Geographical Focus" value={geographicalFocus} />
      )}
      {!!dpStockCode && <Item label="Data Provider Stock Code" value={dpStockCode} /> }
      {!!dpStockExchange && <Item label="Data Provider Stock Exchange" value={dpStockExchange} /> }
      {!!lwStockCode && <Item label="Livewire Stock Code" value={lwStockCode} /> }
      {!!dpFundType && <Item label="Fund Type" value={dpFundType} /> }
    </Container>
  );
}
// eslint-enable-next-line complexity

Fund.propTypes = {
  fund: PropTypes.shape({
    dpFundName: PropTypes.string.isRequired,
    dpFundApir: PropTypes.string,
    dpFundIsin: PropTypes.string,
    dpFundId: PropTypes.string,
    dpFundInceptionDate: PropTypes.string,
    dpFundCurrency: PropTypes.string,
    dpFundLegalStructure: PropTypes.string,
    dpFundDomicile: PropTypes.string,
    dpFundSize: PropTypes.number,
    dpFundSizeDate: PropTypes.string,
    dpFundCategory: PropTypes.string,
    dpFundMinimumInvestment: PropTypes.number,
    dpFundInvestmentVehicleType: PropTypes.string,
    geographicalFocus: PropTypes.string,
    dpStockCode: PropTypes.string,
    dpStockExchange: PropTypes.string,
    lwStockCode: PropTypes.string,
    dpFundType: PropTypes.string,
  }).isRequired,
};
